var map = {
	"./countries/de-DE.json": "5063",
	"./countries/en-GB.json": "b952",
	"./countries/fr-FR.json": "6ed2",
	"./countries/nl-NL.json": "8dd1",
	"./de-DE.json": "6922",
	"./en-GB.json": "282d",
	"./fr-FR.json": "cfe4",
	"./nl-NL.json": "0727",
	"./states/en-GB.json": "1204",
	"./states/nl-NL.json": "1215"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";